import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell } from './components/Layout';
import { RequireAuth, RequireStaff } from './components/Guards';

import { LoginPage } from './pages/Login';
import { RegisterPage } from './pages/Register';
import { ForgotPasswordPage } from './pages/ForgotPassword';
import { ResetPasswordPage } from './pages/ResetPassword';
import { DashboardPage } from './pages/Dashboard';
import { PickFormPage } from './pages/PickForm';
import { StandingsPage } from './pages/Standings';
import { WeeklyResultsPage } from './pages/WeeklyResults';
import { AccountPage } from './pages/Account';
import { StaffInviteAcceptPage } from './pages/StaffInviteAccept';
import { CompleteProfilePage } from './pages/CompleteProfile';
import { LeaguePlayPage } from './pages/LeaguePlay';

import { AdminLayout } from './pages/admin/AdminLayout';
import { AdminDashboardPage } from './pages/admin/AdminDashboard';
import { AdminWeeksPage } from './pages/admin/AdminWeeks';
import { AdminWeekDetailPage } from './pages/admin/AdminWeekDetail';
import { AdminScoringPage } from './pages/admin/AdminScoring';
import { AdminUsersPage } from './pages/admin/AdminUsers';
import { AdminAuditPage } from './pages/admin/AdminAudit';
import { AdminStaffPage } from './pages/admin/AdminStaff';
import { AdminLeaguesPage } from './pages/admin/AdminLeagues';

/** Wraps a player page in the standard app shell. */
function Shell({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <AppShell>{children}</AppShell>
    </RequireAuth>
  );
}

export function App() {
  return (
    <Routes>
      {/* Public auth pages */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/staff-invite/:token" element={<StaffInviteAcceptPage />} />

      {/* Capability URL — the only path to the pick form (from the QR code). */}
      <Route path="/picks/w/:token" element={<PickFormPage />} />

      <Route path="/complete-profile" element={<RequireAuth><CompleteProfilePage /></RequireAuth>} />

      {/* Single-QR landing: focused league chooser (no app shell). */}
      <Route path="/play" element={<RequireAuth><LeaguePlayPage /></RequireAuth>} />

      {/* Player app */}
      <Route path="/" element={<Shell><DashboardPage /></Shell>} />
      <Route path="/standings" element={<Shell><StandingsPage /></Shell>} />
      <Route path="/results" element={<Shell><WeeklyResultsPage /></Shell>} />
      <Route path="/results/:weekId" element={<Shell><WeeklyResultsPage /></Shell>} />
      <Route path="/account" element={<Shell><AccountPage /></Shell>} />

      {/* Admin */}
      <Route
        path="/admin"
        element={
          <RequireStaff>
            <AdminLayout />
          </RequireStaff>
        }
      >
        <Route index element={<AdminDashboardPage />} />
        <Route path="weeks" element={<AdminWeeksPage />} />
        <Route path="weeks/:id" element={<AdminWeekDetailPage />} />
        <Route path="scoring" element={<AdminScoringPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="staff" element={<AdminStaffPage />} />
        <Route path="leagues" element={<AdminLeaguesPage />} />
        <Route path="audit" element={<AdminAuditPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
